/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Tab_LinuxInputs */

const en_fc_dl_tab_linux = /** @type {(inputs: Fc_Dl_Tab_LinuxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linux`)
};

/**
* | output |
* | --- |
* | "Linux" |
*
* @param {Fc_Dl_Tab_LinuxInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_tab_linux = /** @type {((inputs?: Fc_Dl_Tab_LinuxInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Tab_LinuxInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_tab_linux(inputs)
});
export { fc_dl_tab_linux as "fc.dl.tab.linux" }